import axios, { AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { API, getDynamicApiUrl, getEnvConfig } from "../constants";
import Cookies from "js-cookie";

export const phdScannerApiAxios = axios.create({
  baseURL: API,
  timeout: 120000,
  withCredentials: true,
});

// Create a SaaS-specific axios instance
export const saasApiAxios = axios.create({
  baseURL: getDynamicApiUrl(),
  timeout: 120000,
  withCredentials: true,
});

async function addTokenInterceptor(
  config: InternalAxiosRequestConfig,
): Promise<InternalAxiosRequestConfig> {
  const headers = config.headers || {};
  const envConfig = getEnvConfig();
  
  // Add tenant header for SaaS endpoints
  if (envConfig.tenant && envConfig.tenant !== 'www') {
    headers['X-Tenant'] = envConfig.tenant;
  }
  
  // For SaaS API calls, always add Bearer token if available
  const token = localStorage.getItem('token');
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  
  return config;
}

// Add interceptors to both axios instances
phdScannerApiAxios.interceptors.request.use(addTokenInterceptor);
saasApiAxios.interceptors.request.use(addTokenInterceptor);
